import axios from 'axios'

export default {
    checkStatus(userId) {
        return axios.post('/friendships/check-relationships', {user_id: userId})
    },

    createFriendRequest(userId) {
        return axios.post('/friend-requests/create', {user_id: userId})
    },

    acceptFriendRequest(userId) {
        return axios.post('/friend-requests/accept', {user_id: userId})
    },

    denyFriendRequest(userId) {
        return axios.post('/friend-requests/deny', {user_id: userId})
    },
}
